import React from 'react';
import { Controller } from 'react-hook-form';
import { get } from 'lodash';
import { SingleSelectComboBox } from '@tcl-boron-prefabs/single-select-combo-box';

const ControlledSingleSelectComboBox = ({
  control,
  name,
  label,
  placeholder,
  disabled,
  required,
  autoComplete,
  tabIndex,
  className,
  classes,
  style,
  errors,
  options,
  escapeClippingArea,
  validate,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: required ? 'This field is required' : false, validate }}
      render={({ field }) => (
        <SingleSelectComboBox
          onChange={(value) => field.onChange(value?.value)}
          value={options.find((option) => option.value === field.value) ?? null}
          options={options}
          label={label + (required ? ' *' : '')}
          placeholder={placeholder ?? 'Select'}
          disabled={disabled}
          style={style}
          className={className}
          classes={classes}
          escapeClippingArea={escapeClippingArea}
          status={get(errors, name) ? 'error' : 'default'}
          subContent={get(errors, name) ? <div>{get(errors, name)?.message}</div> : null}
          autoComplete={autoComplete}
          tabIndex={tabIndex}
        />
      )}
    />
  );
};

export default ControlledSingleSelectComboBox;
